module.exports = __webpack_public_path__ + "img/popupPanel.1145d14d.jpg";